/* eslint-disable import/order */
import { MenuIdCommunications } from '@jira/navigation-apps__constants/src/MenuIdCommunications.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { communicationsStakeholdersRoute } from '@jira/router-routes__communications-routes/src/communicationsStakeholdersRoute.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { StakeholdersSkeleton } from '@jira/platform__skeletons/src/ui/stakeholder-management/StakeholdersSkeleton.tsx';
import { stakeholdersPageEntrypoint } from './ui/stakeholders/stakeholdersPageEntrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const communicationsStakeholdersRouteEntry: Route = createEntry(
	communicationsStakeholdersRoute,
	() => ({
		group: 'communications',

		navigation: {
			menuId: MenuIdCommunications,
		},

		skeleton: StakeholdersSkeleton,

		entryPoint: () => {
			return stakeholdersPageEntrypoint;
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
